import { useRouter } from "next/router";
import { useEffect } from "react";

import { trackPinterest } from "@/analytics/pinterest";
import { useConsentStore } from "@/consent/useConsentStore";

/** The pages Pinterest counts as product views: the shop, accessories, ads. */
const isProductPage = (pathname: string): boolean =>
  pathname === "/product" ||
  pathname === "/accessories/[product]" ||
  pathname.startsWith("/lp/");

/**
 * Fires `pagevisit` on every arrival at a product page, client-side
 * navigations included; the tag's own `page` only fires on the first load.
 * Sits after ConsentScripts so the tag exists by the first effect.
 */
export default function PinterestPageVisit(): null {
  const router = useRouter();
  const marketing = useConsentStore((s) => s.consent.marketing);
  const path = router.asPath.split(/[?#]/)[0];

  useEffect(() => {
    if (!marketing || !router.isReady || !isProductPage(router.pathname)) {
      return;
    }
    trackPinterest("pagevisit", () => ({}));
  }, [marketing, router.isReady, router.pathname, path]);

  return null;
}
